:host {
  --color-text-default: #{$color-grey-06};
  --color-text-hover: #{$color-grey-08};
  --color-text-selected: #{$color-turquoise-06};
  --color-text-disabled: #{$color-grey-04};

  --item-focus-outline-color: #{$color-turquoise-03};

  --badge-color: #{$color-red-brand-01};
  display: inline-block;
}

.meta-nav-button,
.meta-nav-link {
  appearance: none;
  border: none;
  background: none;
  display: grid;
  grid-auto-flow: row;
  row-gap: 4px;
  align-items: center;
  justify-items: center;
  color: var(--color-text-default);
  padding: 0;
  text-decoration: none;
  cursor: pointer;

  &--selected {
    color: var(--color-text-selected);
  }

  &--badge {
    dc-ui-icon {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        right: -1px;
        bottom: -1px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: var(--badge-color);
        border: 1px solid $color-white;
        background-clip: padding-box;
      }
    }
  }

  &:hover {
    color: var(--color-text-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--item-focus-outline-color);
    outline-offset: 2px;
  }

  &--disabled {
    pointer-events: none;
    color: var(--color-text-disabled);
  }

  span {
    font-family: 'Bosch Sans';
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    letter-spacing: 0.038px;
  }
}

:host([disabled]) {
  pointer-events: none;
}

:host([data-in-main-nav]) {
  .meta-nav-button,
  .meta-nav-link {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
}
